import { SET_DOMAINS } from "../actions/types";

const initialState = {
  domainsList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DOMAINS: {
      return {
        ...state,
        domainsList: action.payload,
      };
    }
    default:
      return state;
  }
}
